import { StatusReferenceBase } from "./status-reference.base";

export class OrderSalesStatusReferenceModel extends StatusReferenceBase {
    public orderSalesStatusCode: string;
    public orderSalesStatusName: string;
    public statusCode: string;
    public highlightColor: string;
}